import React from 'react';
import PageLayout from '../../components/layout/PageLayout';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import CapabilityMatrix from './components/CapabilityMatrix';
import CleanMissionStatement from '../../components/ui/MissionStatement';
import FeaturedTransformation from './components/FeaturedTransformation';
import TrustedClients from './components/TrustedClients';
import InsightsPreview from './components/InsightsPreview';

const Homepage = () => {
  return (
    <PageLayout
      title="Home - Ons Mettle Corporate"
      description="Leading telecommunications engineering solutions with over 10 years of expertise. We connect clients to tomorrow's technology today."
      keywords={['telecommunications', 'engineering', 'infrastructure', 'technology solutions']}
    >
      <HeroSection />
      <CapabilityMatrix />
      <CleanMissionStatement />
      <FeaturedTransformation />
      <TrustedClients />
      <InsightsPreview />
      <Footer />
    </PageLayout>
  );
};

export default Homepage;